import { useNavigate } from "react-router-dom";
import Button from "../../../../ui/Button";
import { AddIcon } from "../../../../utils/icon.utils";
import { useQueryParams } from "../../../../utils/queryParams.utils";
import { displayCarInfo } from "../../../../utils/stockList.utils";

export default function VehicleShowroomWorksAddButton({ data }) {
  const { fullPath: redirectTo } = useQueryParams();
  const navigate = useNavigate();

  function handleAdd() {
    navigate(`/stock-list/showroom-works/add`, {
      state: { data: displayCarInfo(data), redirectTo }
    });
  }

  return (
    <div className="text-center">
      <Button icon={AddIcon} name="Add" onClick={handleAdd} />
    </div>
  );
}
